import { render, staticRenderFns } from "./UserDetails.vue?vue&type=template&id=7dd88f2d&scoped=true&"
import script from "./UserDetails.vue?vue&type=script&lang=ts&"
export * from "./UserDetails.vue?vue&type=script&lang=ts&"
import style0 from "./UserDetails.vue?vue&type=style&index=0&id=7dd88f2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd88f2d",
  null
  
)

export default component.exports